const INITIAL_STATE = {
  items: [],
  readComics: {},
  didInvalidate: true,
  fetchingInProgressSince: null,
  lastSuccessfulFetch: null,
  lastFailedFetch: null,
  lastErrorMessage: null,
  sortOrder: -1,
};

module.exports = function ComicsReducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case 'SET_API_URL':
      return INITIAL_STATE;
    case 'LOGIN_SUCCESSFUL':
    case 'SET_LANGUAGE':
    case 'INVALIDATE_COMICS':
      return {
        ...state,
        didInvalidate: true,
      };
    case 'SETORDER':
      return {
        ...state,
        items: [...state.items].reverse(),
        sortOrder: -state.sortOrder,
      };
    case 'LOGOUT_SUCCESSFUL':
      return {
        ...state,
        items: state.items.filter(
          (comic) => new Date(comic.availableFrom) < new Date(),
        ),
        readComics: {},
      };
    case 'FETCH_COMICS_IN_PROGRESS': {
      return {
        ...state,
        fetchingInProgressSince: action.timestamp,
      };
    }
    case 'FETCH_COMICS_SUCCESSFUL':
      return {
        ...state,
        didInvalidate: false,
        fetchingInProgressSince: null,
        lastSuccessfulFetch: action.timestamp,
        items: state.sortOrder > 0 ? action.comics.reverse() : action.comics,
      };
    case 'FETCH_COMICS_FAILED':
      return {
        ...state,
        fetchingInProgressSince: null,
        lastFailedFetch: action.timestamp,
        lastErrorMessage: action.reason,
      };
    case 'ADD_COMICS':
      return {
        ...state,
        items: [...state.items, ...action.comics],
      };
    default:
      return state;
  }
};
